'use client'

import { ButtonHTMLAttributes } from 'react';

interface BackProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    content: string
}


export default function ShareButton({ content, ...props }: BackProps) {

    const handleShare = async () => {
        try {
            if (navigator.share) {
                await navigator.share({
                    url: content,
                });
            } else {
                // console.log('Web Share API not supported in this browser.');
            }
        } catch (error) {
            console.error('Error sharing content:', error);
        }

    };
    return (
        <button
            onClick={(e) => {
                props.onClick && props.onClick(e);
                handleShare();
            }}
            {...props}
            aria-label={'Share'}
            name={props.name || 'share-button'}
        >
            {props.children}
        </button>
    );
}